import React from 'react';
import styled from 'styled-components';
import { FaLinkedin, FaGithub, FaInstagram } from 'react-icons/fa';  
import '../App.css';
const HackerRankIcon = styled.img`
  width: 32px;
  height: 32px;
  border-radius:20px;
`;

const ContactContainer = styled.div`
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.textColor};
  padding: 50px 50px;
`;

const ContactContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 350px; /* Increase the gap for more spacing on larger screens */
  flex-wrap: nowrap;

  @media (max-width: 900px) {
    gap: 40px; /* Adjust the gap for smaller screens */
    flex-wrap: wrap; /* Wrap content for smaller screens */
  }

  @media (max-width: 400px) {
    flex-direction: column;
    gap: 100px; /* Adjust the gap for very small screens */
    margin-top: 30px; /* Shift content down for small screens */
  }
`;

const ContentSection = styled.div`
  flex: 1;

  @media (max-width: 400px) {
    min-width: 100%; /* Make the section full width on very small screens */
  }
`;

const ContactHeading = styled.h2`
  margin-bottom: 20px; /* Maintain the same spacing */
`;

const FormContainer = styled.div`
  flex: 1;
  padding: 30px;
  border: 5px solid ${({ theme }) => theme.textColor};
  border-radius: 10px;
  min-width: 480px;

  @media (max-width: 400px) {
    min-width: 150px; 
    padding: 8px;
  }
`;

const FormHeading = styled.h2`
  margin-bottom: 20px;
  margin-top: 20px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const Input = styled.input`
  padding: 10px;
  font-size: 16px;
  font-family: Poppins, sans-serif;
  border: 1px solid ${({ theme }) => theme.textColor};
  border-radius: 20px;
`;

const Textarea = styled.textarea`
  padding: 10px;
  font-size: 16px;
  border: 1px solid ${({ theme }) => theme.textColor};
  border-radius: 20px;
  font-family: Poppins, sans-serif;
`;

const SubmitButton = styled.button`
  background: #25b79f;
  color: ${({ theme }) => theme.background};
  font-size: 16px;
  font-family: Poppins, sans-serif;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  margin-left: 90px;
  width: 250px;
  height: 40px;

  &:hover {
    background: #07374a;
  }

  @media (max-width: 400px) {
    max-width: 200px;
    margin-left: 35px;
  }
`;

const Footer = styled.footer`
  background: ${({ theme }) => theme.textColor};
  color: ${({ theme }) => theme.background};
  text-align: center;
  padding: 32px;
`;

const SocialList = styled.ul`
  list-style: none;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 900px) {
    flex-wrap: wrap;
  }

  @media (max-width: 400px) {
    flex-direction: column;
    gap: 20px;
  }
`;

const SocialItem = styled.li`
  margin: 0 10px;
  position: relative;
`;

const Tooltip = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  color: ${({ theme }) => theme.textColor};
  padding: 6px 10px;
  border-radius: 5px;
  opacity: 0;
  visibility: hidden;
  font-size: 14px;
  transition: all 0.3s ease;

  ${SocialItem}:hover & {
    opacity: 1;
    visibility: visible;
    top: 50px;
  }
`;

const SocialLink = styled.a`
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  color: #4d4d4d;
  background-color: #fff;
  transition: all 0.3s ease-in-out;

  &:hover {
    box-shadow: 3px 2px 45px 0px rgb(0 0 0 / 12%);
    color: white;
  }

  & .filled {
    position: absolute;
    top: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0;
    background-color: #07374A;
    transition: all 0.25s ease-in-out;
  }

  &:hover .filled {
    height: 100%;
  }
`;

const LinkedIn = styled(FaLinkedin)`
  color: #0274b3;
`;

const GitHub = styled(FaGithub)`
  color: #24262a;
`;

const Instagram = styled(FaInstagram)`
   background: #f09433; 
background: -moz-linear-gradient(15deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%); 
background: -webkit-linear-gradient(5deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%); 
background: linear-gradient(15deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%); 
  border-radius: 11px;
  height: 30px;
  width: 28px;
  color: #000;
`;


const Contact = () => {
  return (
    <>
      <ContactContainer className="contact" id="connect-me">
        <div className="container">
          <ContactContent className="contact-content">
            <FormContainer>
              <FormHeading><b>Reach out to me!</b></FormHeading>
              <Form method="post" id="contactForm" name="contactForm">
                <Input type="text" name="fname" id="fname" placeholder="First name" required />
                <Input type="text" name="lname" id="lname" placeholder="Last name" required />
                <Input type="email" name="email" id="email" placeholder="Your Work Email" required />
                <Textarea name="message" id="message" cols="30" rows="7" placeholder="Write me as you wish...." required></Textarea>
                <p>&nbsp;</p>
                <SubmitButton type="submit">Send Message</SubmitButton>
              </Form>
            </FormContainer>
            
            <ContentSection>
              <ContactHeading style={{ fontSize: "40px" }}>Contact Me <b>Lets Connect!</b></ContactHeading>
              <p style={{ fontSize: "20px" }}>
                You can reach me via email : <a href="mailto:ayush.dey@example.com"><b>ayush2004dey@gmail.com</b></a>
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              
              <p style={{ fontSize: "25px" }}><b>Other Socials</b></p>
              &nbsp;
              <SocialList className="example-2">
                <SocialItem className="icon-content">
                  <SocialLink href="https://www.linkedin.com/in/ayush-dey-36919825a/" aria-label="LinkedIn" data-social="linkedin">
                    <div className="filled"></div>
                    <LinkedIn size="30px" />
                  </SocialLink>
                  <Tooltip className="tooltip">LinkedIn</Tooltip>
                </SocialItem>
                <SocialItem className="icon-content">
                  <SocialLink href="https://www.github.com/adx04" aria-label="GitHub" data-social="github">
                    <div className="filled"></div>
                    <GitHub size="30px" />
                  </SocialLink>
                  <Tooltip className="tooltip">GitHub</Tooltip>
                </SocialItem>
                <SocialItem className="icon-content">
                  <SocialLink href="https://www.instagram.com/deep._.ad" aria-label="Instagram" data-social="instagram">
                    <div className="filled"></div>
                    <Instagram size="30px" />
                  </SocialLink>
                  <Tooltip className="tooltip">Instagram</Tooltip>
                </SocialItem>
                <SocialItem className="icon-content">
                  <SocialLink href="https://www.hackerrank.com/profile/adx04" aria-label="HackerRank" data-social="hackerrank">
                    <div className="filled"></div>
                    <HackerRankIcon src="https://i.ibb.co/3Mqmg9b/Hacker-Rank-Icon-1000px-removebg-preview.png" alt="HackerRank" />
                  </SocialLink>
                  <Tooltip className="tooltip">HackerRank</Tooltip>
                </SocialItem>
              </SocialList>
            </ContentSection>
          </ContactContent>
        </div>
      </ContactContainer>
      <Footer>
        © <b>Made by Ayush Dey</b>
      </Footer>
    </>
  );
};

export default Contact;
